export const HOME = "/";
export const CREATE = "/create";
export const READ = "/read/:id";
export const UPDATE = "/update/:id";
export const DELETE = "/delete/:id";
// Url адреса для веб приложения